"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardHeaderViewController = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const PageWizard_1 = require("../../../PageWizard");
const isCustomHeader = (header) => {
    return !(header === null || header === void 0 ? void 0 : header.title);
};
class PageWizardHeaderViewController extends core_1.ReactViewController {
    constructor(config) {
        const hasCustomHeader = isCustomHeader(config);
        const headerConfig = hasCustomHeader ? { title: '' } : config;
        super(Object.assign({ element: hasCustomHeader ? config : null }, headerConfig));
    }
    createElement(_a) {
        var { element } = _a, props = __rest(_a, ["element"]);
        return element !== null && element !== void 0 ? element : react_1.default.createElement(PageWizard_1.PageWizardHeader, Object.assign({}, props));
    }
    replace(viewController) {
        this.setState(Object.assign(Object.assign({}, this.getState()), { element: viewController.render() }));
    }
    updateHeader(props) {
        const currentState = this.getState();
        if (currentState.element !== null) {
            console.warn('Custom PageWizard header cannot be updated dynamically');
        }
        else {
            this.setState(Object.assign(Object.assign({}, currentState), props));
        }
    }
}
exports.PageWizardHeaderViewController = PageWizardHeaderViewController;
//# sourceMappingURL=PageWizardHeaderViewController.js.map